import { ACCESS_PERIPHERAL_TYPES } from 'helpers/globals'

export default function deletePeripheral(state, action) {
  const { peripheralType, id, doorId } = action
  const { entities, entities: { doors } } = state
  const peripherals = entities[peripheralType]

  if (!ACCESS_PERIPHERAL_TYPES.includes(peripheralType) || !peripherals) return state

  const byId = { ...peripherals.byId }
  delete byId[id]

  const door = doors.byId[doorId]

  return Object.assign({}, state, {
    entities: {
      ...entities,
      doors: {
        allIds: doors.allIds,
        byId: Object.assign({}, doors.byId, door && {
          [doorId]: {
            ...door,
            [peripheralType]: door[peripheralType].filter(currentId => currentId !== id)
          }
        })
      },
      [peripheralType]: {
        byId,
        allIds: peripherals.allIds.filter(currentId => currentId !== id)
      }
    }
  })
}



// WEBPACK FOOTER //
// ./src/reducers/deletePeripheral.js